import React from 'react';

const AddplusIcon = (props) =>
  <div
    onClick={props.onClick !== undefined ? props.onClick : undefined}
    className={"col-xs-12 col-sm-6 col-md-4"}
    style={{cursor: "pointer"}}
    title={"افزودن"}
  >
    <div
      style={{
        width: '367px',
        height: '270px',
        background: 'rgb(255, 255, 255)',
        boxShadow: 'rgb(0 0 0 / 5%) 0px 3px 4px 2px',
        borderRadius: '10px',
        padding: '30px 20px',
        overflow: 'hidden',
        margin: '10px 0px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <i className="fa fa-plus fa-2x" aria-hidden="true"/>
    </div>
  </div>

export default AddplusIcon;
